import React from 'react';
import { sistemaTotalRows } from '../data/comparaciones';
import { Emoji } from './Emoji';
export function SistemaTotal() {
  return <section className="w-full bg-forest-800 py-20" data-id="element-205" data-mp="n82s2e84td16">
      <div className="mx-auto max-w-[680px] px-5 text-center sm:px-8" data-id="element-206" data-mp="10xo4t6vc8w0r">
        <p className="inline-flex items-center gap-2 font-display text-sm font-extrabold uppercase tracking-[0.16em] text-lime-400" data-id="element-207" data-mp="10zr28bytlrfi">
          <Emoji symbol="🕊️" data-id="element-208" data-mp="1avkk8avb6d4o" />
          Solo en Mega Pack + Sistema Total
        </p>
        <h2 className="mt-3 font-display text-3xl font-extrabold leading-[1.08] tracking-tight text-cream sm:text-4xl" data-id="element-209" data-mp="15x9b62cu86ni">
          ¿Qué agrega el Sistema Total?
        </h2>

        <ul className="mt-10 flex flex-col gap-4 text-left" data-id="element-210" data-mp="1juft5upqm1bo">
          {sistemaTotalRows.map(row => <li key={row.situation} className="overflow-hidden rounded-2xl border border-line bg-pistacho" data-id="element-211" data-mp="1ftcal0gb1r6r">
              <p className="bg-forest-900 px-5 py-4 font-display text-[15px] font-bold text-cream" data-id="element-212" data-mp="3hnlcnbmaqjq7">
                {row.situation}
              </p>
              <div className="flex items-start gap-3 border-b border-line px-5 py-4" data-id="element-213" data-mp="7qt1a84qsbc3">
                <Emoji symbol="❌" className="mt-0.5" data-id="element-214" data-mp="7oqahlvrme6b" />
                <span className="text-[15px] text-forest-700" data-id="element-215" data-mp="couuhlvvtr1a">
                  <span className="font-semibold text-clay" data-id="element-216" data-mp="hgmf7fscx2ji">Sin Sistema Total: </span>
                  {row.without}
                </span>
              </div>
              <div className="flex items-start gap-3 px-5 py-4" data-id="element-217" data-mp="mf63hmufaqf1">
                <Emoji symbol="✅" className="mt-0.5" data-id="element-218" data-mp="qgj67o27ydhq" />
                <span className="text-[15px] font-medium text-forest-900" data-id="element-219" data-mp="qj5czlhacoyw">
                  <span className="font-bold text-lime-700" data-id="element-220" data-mp="vgx80od88r7b">
                    Con Sistema Total:{' '}
                  </span>
                  {row.with}
                </span>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}